var items = {
  "block.minecraft.air": "vzduch",
  "block.minecraft.stone": "kámen",
  "block.minecraft.granite": "žula",
  "block.minecraft.polished_granite": "leštěná žula",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "leštěný diorit",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "leštěný andezit",
  "block.minecraft.grass_block": "trávník",
  "block.minecraft.dirt": "hlína",
  "block.minecraft.coarse_dirt": "hrubá hlína",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "karmínové podhoubí",
  "block.minecraft.warped_nylium": "přízračné podhoubí",
  "block.minecraft.cobblestone": "kamení",
  "block.minecraft.oak_planks": "dubová prkna",
  "block.minecraft.spruce_planks": "smrková prkna",
  "block.minecraft.birch_planks": "březová prkna",
  "block.minecraft.jungle_planks": "prkna z tropického dřeva",
  "block.minecraft.acacia_planks": "akáciová prkna",
  "block.minecraft.dark_oak_planks": "prkna z tmavého dubu",
  "block.minecraft.crimson_planks": "karmínová prkna",
  "block.minecraft.warped_planks": "přízračná prkna",
  "block.minecraft.oak_sapling": "sazenice dubu",
  "block.minecraft.spruce_sapling": "sazenice smrku",
  "block.minecraft.birch_sapling": "sazenice břízy",
  "block.minecraft.jungle_sapling": "sazenice tropického stromu",
  "block.minecraft.acacia_sapling": "sazenice akácie",
  "block.minecraft.dark_oak_sapling": "sazenice tmavého dubu",
  "block.minecraft.bedrock": "podloží",
  "block.minecraft.sand": "písek",
  "block.minecraft.red_sand": "rudý písek",
  "block.minecraft.gravel": "štěrk",
  "block.minecraft.gold_ore": "zlatá ruda",
  "block.minecraft.iron_ore": "železná ruda",
  "block.minecraft.coal_ore": "ložisko uhlí",
  "block.minecraft.nether_gold_ore": "netherová zlatá ruda",
  "block.minecraft.oak_log": "dubový kmen",
  "block.minecraft.spruce_log": "smrkový kmen",
  "block.minecraft.birch_log": "březový kmen",
  "block.minecraft.jungle_log": "kmen z tropického stromu",
  "block.minecraft.acacia_log": "akáciový kmen",
  "block.minecraft.dark_oak_log": "kmen z tmavého dubu",
  "block.minecraft.crimson_stem": "karmínová třeň",
  "block.minecraft.warped_stem": "přízračná třeň",
  "block.minecraft.stripped_oak_log": "oloupaný dubový kmen",
  "block.minecraft.stripped_spruce_log": "oloupaný smrkový kmen",
  "block.minecraft.stripped_birch_log": "oloupaný březový kmen",
  "block.minecraft.stripped_jungle_log": "oloupaný kmen z tropického stromu",
  "block.minecraft.stripped_acacia_log": "oloupaný akáciový kmen",
  "block.minecraft.stripped_dark_oak_log": "oloupaný kmen z tmavého dubu",
  "block.minecraft.stripped_crimson_stem": "oloupaná karmínová třeň",
  "block.minecraft.stripped_warped_stem": "oloupaná přízračná třeň",
  "block.minecraft.stripped_oak_wood": "oloupané dubové dřevo",
  "block.minecraft.stripped_spruce_wood": "oloupané smrkové dřevo",
  "block.minecraft.stripped_birch_wood": "oloupané březové dřevo",
  "block.minecraft.stripped_jungle_wood": "oloupané tropické dřevo",
  "block.minecraft.stripped_acacia_wood": "oloupané akáciové dřevo",
  "block.minecraft.stripped_dark_oak_wood": "oloupané dřevo z tmavého dubu",
  "block.minecraft.stripped_crimson_hyphae": "oloupaná karmínová stélka",
  "block.minecraft.stripped_warped_hyphae": "oloupaná přízračná stélka",
  "block.minecraft.oak_wood": "dubové dřevo",
  "block.minecraft.spruce_wood": "smrkové dřevo",
  "block.minecraft.birch_wood": "březové dřevo",
  "block.minecraft.jungle_wood": "tropické dřevo",
  "block.minecraft.acacia_wood": "akáciové dřevo",
  "block.minecraft.dark_oak_wood": "dřevo z tmavého dubu",
  "block.minecraft.crimson_hyphae": "karmínová stélka",
  "block.minecraft.warped_hyphae": "přízračná stélka",
  "block.minecraft.oak_leaves": "dubové listí",
  "block.minecraft.spruce_leaves": "smrkové jehličí",
  "block.minecraft.birch_leaves": "březové listí",
  "block.minecraft.jungle_leaves": "tropické listí",
  "block.minecraft.acacia_leaves": "akáciové listí",
  "block.minecraft.dark_oak_leaves": "listí tmavého dubu",
  "block.minecraft.sponge": "mořská houba",
  "block.minecraft.wet_sponge": "mokrá mořská houba",
  "block.minecraft.glass": "sklo",
  "block.minecraft.lapis_ore": "ložisko lazuritu",
  "block.minecraft.lapis_block": "blok lazuritu",
  "block.minecraft.dispenser": "dávkovač",
  "block.minecraft.sandstone": "pískovec",
  "block.minecraft.chiseled_sandstone": "opracovaný pískovec",
  "block.minecraft.cut_sandstone": "řezaný pískovec",
  "block.minecraft.note_block": "hudební blok",
  "block.minecraft.powered_rail": "napájená kolej",
  "block.minecraft.detector_rail": "senzorová kolej",
  "block.minecraft.sticky_piston": "lepivý píst",
  "block.minecraft.cobweb": "pavučina",
  "block.minecraft.grass": "tráva",
  "block.minecraft.fern": "kapradina",
  "block.minecraft.dead_bush": "suché křoví",
  "block.minecraft.seagrass": "mořská tráva",
  "block.minecraft.sea_pickle": "ohnivka",
  "block.minecraft.piston": "píst",
  "block.minecraft.white_wool": "bílá vlna",
  "block.minecraft.orange_wool": "oranžová vlna",
  "block.minecraft.magenta_wool": "purpurová vlna",
  "block.minecraft.light_blue_wool": "světle modrá vlna",
  "block.minecraft.yellow_wool": "žlutá vlna",
  "block.minecraft.lime_wool": "světle zelená vlna",
  "block.minecraft.pink_wool": "růžová vlna",
  "block.minecraft.gray_wool": "šedá vlna",
  "block.minecraft.light_gray_wool": "světle šedá vlna",
  "block.minecraft.cyan_wool": "azurová vlna",
  "block.minecraft.purple_wool": "fialová vlna",
  "block.minecraft.blue_wool": "modrá vlna",
  "block.minecraft.brown_wool": "hnědá vlna",
  "block.minecraft.green_wool": "zelená vlna",
  "block.minecraft.red_wool": "červená vlna",
  "block.minecraft.black_wool": "černá vlna",
  "block.minecraft.dandelion": "pampeliška",
  "block.minecraft.poppy": "vlčí mák",
  "block.minecraft.blue_orchid": "modrá orchidej",
  "block.minecraft.allium": "česnek",
  "block.minecraft.azure_bluet": "houstonie modrá",
  "block.minecraft.red_tulip": "červený tulipán",
  "block.minecraft.orange_tulip": "oranžový tulipán",
  "block.minecraft.white_tulip": "bílý tulipán",
  "block.minecraft.pink_tulip": "růžový tulipán",
  "block.minecraft.oxeye_daisy": "kopretina",
  "block.minecraft.cornflower": "chrpa",
  "block.minecraft.lily_of_the_valley": "konvalinka",
  "block.minecraft.wither_rose": "witherova růže",
  "block.minecraft.brown_mushroom": "hřib",
  "block.minecraft.red_mushroom": "muchomůrka",
  "block.minecraft.crimson_fungus": "karmínová houba",
  "block.minecraft.warped_fungus": "přízračná houba",
  "block.minecraft.crimson_roots": "karmínové kořínky",
  "block.minecraft.warped_roots": "přízračné kořínky",
  "block.minecraft.nether_sprouts": "netherové výhonky",
  "block.minecraft.weeping_vines": "karmínová liána",
  "block.minecraft.twisting_vines": "přízračná liána",
  "block.minecraft.sugar_cane": "cukrová třtina",
  "block.minecraft.kelp": "chaluha",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "blok zlata",
  "block.minecraft.iron_block": "blok železa",
  "block.minecraft.oak_slab": "dubový půlblok",
  "block.minecraft.spruce_slab": "smrkový půlblok",
  "block.minecraft.birch_slab": "březový půlblok",
  "block.minecraft.jungle_slab": "půlblok z tropického dřeva",
  "block.minecraft.acacia_slab": "akáciový půlblok",
  "block.minecraft.dark_oak_slab": "půlblok z tmavého dubu",
  "block.minecraft.crimson_slab": "karmínový půlblok",
  "block.minecraft.warped_slab": "přízračný půlblok",
  "block.minecraft.stone_slab": "kamenný půlblok",
  "block.minecraft.smooth_stone_slab": "půlblok z hladkého kamene",
  "block.minecraft.sandstone_slab": "pískovcový půlblok",
  "block.minecraft.cut_sandstone_slab": "půlblok řezaného pískovce",
  "block.minecraft.petrified_oak_slab": "zkamenělý dubový půlblok",
  "block.minecraft.cobblestone_slab": "půlblok z kamení",
  "block.minecraft.brick_slab": "cihlový půlblok",
  "block.minecraft.stone_brick_slab": "půlblok z kamenných cihel",
  "block.minecraft.nether_brick_slab": "půlblok z netherových cihel",
  "block.minecraft.quartz_slab": "křemenný půlblok",
  "block.minecraft.red_sandstone_slab": "půlblok z rudého pískovce",
  "block.minecraft.cut_red_sandstone_slab": "půlblok řezaného rudého pískovce",
  "block.minecraft.purpur_slab": "purpurový půlblok",
  "block.minecraft.prismarine_slab": "prismarínový půlblok",
  "block.minecraft.prismarine_brick_slab": "půlblok z prismarínových cihel",
  "block.minecraft.dark_prismarine_slab": "půlblok z tmavého prismarínu",
  "block.minecraft.smooth_quartz": "blok hladkého křemene",
  "block.minecraft.smooth_red_sandstone": "vyhlazený rudý pískovec",
  "block.minecraft.smooth_sandstone": "vyhlazený pískovec",
  "block.minecraft.smooth_stone": "hladký kámen",
  "block.minecraft.bricks": "cihly",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "knihovna",
  "block.minecraft.mossy_cobblestone": "kamení porostlé mechem",
  "block.minecraft.obsidian": "obsidián",
  "block.minecraft.torch": "louč",
  "block.minecraft.end_rod": "enderitová tyč",
  "block.minecraft.chorus_plant": "chorus",
  "block.minecraft.chorus_flower": "květ chorusu",
  "block.minecraft.purpur_block": "blok purpuru",
  "block.minecraft.purpur_pillar": "purpurový pilíř",
  "block.minecraft.purpur_stairs": "purpurové schody",
  "block.minecraft.spawner": "líheň",
  "block.minecraft.oak_stairs": "dubové schody",
  "block.minecraft.chest": "truhla",
  "block.minecraft.diamond_ore": "diamantové ložisko",
  "block.minecraft.diamond_block": "diamantový blok",
  "block.minecraft.crafting_table": "pracovní stůl",
  "block.minecraft.farmland": "ornice",
  "block.minecraft.furnace": "pec",
  "block.minecraft.ladder": "žebřík",
  "block.minecraft.rail": "kolej",
  "block.minecraft.cobblestone_stairs": "schody z kamení",
  "block.minecraft.lever": "páka",
  "block.minecraft.stone_pressure_plate": "kamenná nášlapná deska",
  "block.minecraft.oak_pressure_plate": "dubová nášlapná deska",
  "block.minecraft.spruce_pressure_plate": "smrková nášlapná deska",
  "block.minecraft.birch_pressure_plate": "březová nášlapná deska",
  "block.minecraft.jungle_pressure_plate": "nášlapná deska z tropického dřeva",
  "block.minecraft.acacia_pressure_plate": "akáciová nášlapná deska",
  "block.minecraft.dark_oak_pressure_plate": "nášlapná deska z tmavého dubu",
  "block.minecraft.crimson_pressure_plate": "karmínová nášlapná deska",
  "block.minecraft.warped_pressure_plate": "přízračná nášlapná deska",
  "block.minecraft.polished_blackstone_pressure_plate": "nášlapná deska z leštěného černokamene",
  "block.minecraft.redstone_ore": "ruditové ložisko",
  "block.minecraft.redstone_torch": "ruditová louč",
  "block.minecraft.snow": "sníh",
  "block.minecraft.ice": "led",
  "block.minecraft.snow_block": "blok sněhu",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "blok jílu",
  "block.minecraft.jukebox": "hrací skříň",
  "block.minecraft.oak_fence": "dubový plot",
  "block.minecraft.spruce_fence": "smrkový plot",
  "block.minecraft.birch_fence": "březový plot",
  "block.minecraft.jungle_fence": "plot z tropického dřeva",
  "block.minecraft.acacia_fence": "akáciový plot",
  "block.minecraft.dark_oak_fence": "plot z tmavého dubu",
  "block.minecraft.crimson_fence": "karmínový plot",
  "block.minecraft.warped_fence": "přízračný plot",
  "block.minecraft.pumpkin": "dýně",
  "block.minecraft.carved_pumpkin": "vydlabaná dýně",
  "block.minecraft.netherrack": "netherová suť",
  "block.minecraft.soul_sand": "písek duší",
  "block.minecraft.soul_soil": "půda duší",
  "block.minecraft.basalt": "čedič",
  "block.minecraft.polished_basalt": "leštěný čedič",
  "block.minecraft.soul_torch": "louč duší",
  "block.minecraft.glowstone": "světlit",
  "block.minecraft.jack_o_lantern": "svítící dýně",
  "block.minecraft.oak_trapdoor": "dubový poklop",
  "block.minecraft.spruce_trapdoor": "smrkový poklop",
  "block.minecraft.birch_trapdoor": "březový poklop",
  "block.minecraft.jungle_trapdoor": "poklop z tropického dřeva",
  "block.minecraft.acacia_trapdoor": "akáciový poklop",
  "block.minecraft.dark_oak_trapdoor": "poklop z tmavého dubu",
  "block.minecraft.crimson_trapdoor": "karmínový poklop",
  "block.minecraft.warped_trapdoor": "přízračný poklop",
  "block.minecraft.infested_stone": "zamořený kámen",
  "block.minecraft.infested_cobblestone": "zamořené kamení",
  "block.minecraft.infested_stone_bricks": "zamořené kamenné cihly",
  "block.minecraft.infested_mossy_stone_bricks": "zamořené omšelé kamenné cihly",
  "block.minecraft.infested_cracked_stone_bricks": "zamořené popraskané kamenné cihly",
  "block.minecraft.infested_chiseled_stone_bricks": "zamořené opracované kamenné cihly",
  "block.minecraft.stone_bricks": "kamenné cihly",
  "block.minecraft.mossy_stone_bricks": "omšelé kamenné cihly",
  "block.minecraft.cracked_stone_bricks": "popraskané kamenné cihly",
  "block.minecraft.chiseled_stone_bricks": "opracované kamenné cihly",
  "block.minecraft.brown_mushroom_block": "hřibový blok",
  "block.minecraft.red_mushroom_block": "muchomůrkový blok",
  "block.minecraft.mushroom_stem": "třeň",
  "block.minecraft.iron_bars": "železné mříže",
  "block.minecraft.chain": "řetěz",
  "block.minecraft.glass_pane": "tabulka skla",
  "block.minecraft.melon": "meloun",
  "block.minecraft.vine": "liána",
  "block.minecraft.oak_fence_gate": "dubová branka",
  "block.minecraft.spruce_fence_gate": "smrková branka",
  "block.minecraft.birch_fence_gate": "březová branka",
  "block.minecraft.jungle_fence_gate": "branka z tropického dřeva",
  "block.minecraft.acacia_fence_gate": "akáciová branka",
  "block.minecraft.dark_oak_fence_gate": "branka z tmavého dubu",
  "block.minecraft.crimson_fence_gate": "karmínová branka",
  "block.minecraft.warped_fence_gate": "přízračná branka",
  "block.minecraft.brick_stairs": "cihlové schody",
  "block.minecraft.stone_brick_stairs": "schody z kamenných cihel",
  "block.minecraft.mycelium": "podhoubí",
  "block.minecraft.lily_pad": "leknín",
  "block.minecraft.nether_bricks": "netherové cihly",
  "block.minecraft.cracked_nether_bricks": "popraskané netherové cihly",
  "block.minecraft.chiseled_nether_bricks": "opracované netherové cihly",
  "block.minecraft.nether_brick_fence": "plot z netherových cihel",
  "block.minecraft.nether_brick_stairs": "schody z netherových cihel",
  "block.minecraft.enchanting_table": "oltář očarování",
  "block.minecraft.end_portal_frame": "rám portálu do endu",
  "block.minecraft.end_stone": "enderit",
  "block.minecraft.end_stone_bricks": "enderitové cihly",
  "block.minecraft.dragon_egg": "dračí vejce",
  "block.minecraft.redstone_lamp": "ruditová lampa",
  "block.minecraft.sandstone_stairs": "pískovcové schody",
  "block.minecraft.emerald_ore": "smaragdové ložisko",
  "block.minecraft.ender_chest": "enderitová truhla",
  "block.minecraft.tripwire_hook": "uchycení nástražného drátu",
  "block.minecraft.emerald_block": "smaragdový blok",
  "block.minecraft.spruce_stairs": "smrkové schody",
  "block.minecraft.birch_stairs": "březové schody",
  "block.minecraft.jungle_stairs": "schody z tropického dřeva",
  "block.minecraft.crimson_stairs": "karmínové schody",
  "block.minecraft.warped_stairs": "přízračné schody",
  "block.minecraft.command_block": "příkazový blok",
  "block.minecraft.beacon": "maják",
  "block.minecraft.cobblestone_wall": "zídka z kamení",
  "block.minecraft.mossy_cobblestone_wall": "omšelá zídka z kamení",
  "block.minecraft.brick_wall": "cihlová zídka",
  "block.minecraft.prismarine_wall": "prismarínová zídka",
  "block.minecraft.red_sandstone_wall": "zídka z rudého pískovce",
  "block.minecraft.mossy_stone_brick_wall": "omšelá zídka z kamenných cihel",
  "block.minecraft.granite_wall": "žulová zídka",
  "block.minecraft.stone_brick_wall": "zídka z kamenných cihel",
  "block.minecraft.nether_brick_wall": "zídka z netherových cihel",
  "block.minecraft.andesite_wall": "andezitová zídka",
  "block.minecraft.red_nether_brick_wall": "zídka z rudých netherových cihel",
  "block.minecraft.sandstone_wall": "pískovcová zídka",
  "block.minecraft.end_stone_brick_wall": "zídka z enderitových cihel",
  "block.minecraft.diorite_wall": "dioritová zídka",
  "block.minecraft.blackstone_wall": "černokamenná zídka",
  "block.minecraft.polished_blackstone_wall": "zídka z leštěného černokamene",
  "block.minecraft.polished_blackstone_brick_wall": "zídka z cihel z leštěného černokamene",
  "block.minecraft.stone_button": "kamenné tlačítko",
  "block.minecraft.oak_button": "dubové tlačítko",
  "block.minecraft.spruce_button": "smrkové tlačítko",
  "block.minecraft.birch_button": "březové tlačítko",
  "block.minecraft.jungle_button": "tlačítko z tropického dřeva",
  "block.minecraft.acacia_button": "akáciové tlačítko",
  "block.minecraft.dark_oak_button": "tlačítko z tmavého dubu",
  "block.minecraft.crimson_button": "karmínové tlačítko",
  "block.minecraft.warped_button": "přízračné tlačítko",
  "block.minecraft.polished_blackstone_button": "tlačítko z leštěného černokamene",
  "block.minecraft.anvil": "kovadlina",
  "block.minecraft.chipped_anvil": "opotřebená kovadlina",
  "block.minecraft.damaged_anvil": "poškozená kovadlina",
  "block.minecraft.trapped_chest": "nástražná truhla",
  "block.minecraft.light_weighted_pressure_plate": "citlivá vážní nášlapná deska",
  "block.minecraft.heavy_weighted_pressure_plate": "zátěžová vážní nášlapná deska",
  "block.minecraft.daylight_detector": "senzor denního světla",
  "block.minecraft.redstone_block": "ruditový blok",
  "block.minecraft.nether_quartz_ore": "ložisko netherového křemene",
  "block.minecraft.hopper": "násypka",
  "block.minecraft.chiseled_quartz_block": "opracovaný blok křemene",
  "block.minecraft.quartz_block": "blok křemene",
  "block.minecraft.quartz_bricks": "křemenné cihly",
  "block.minecraft.quartz_pillar": "křemenný pilíř",
  "block.minecraft.quartz_stairs": "křemenné schody",
  "block.minecraft.activator_rail": "aktivační kolej",
  "block.minecraft.dropper": "podavač",
  "block.minecraft.white_terracotta": "bílá terakota",
  "block.minecraft.orange_terracotta": "oranžová terakota",
  "block.minecraft.magenta_terracotta": "purpurová terakota",
  "block.minecraft.light_blue_terracotta": "světle modrá terakota",
  "block.minecraft.yellow_terracotta": "žlutá terakota",
  "block.minecraft.lime_terracotta": "světle zelená terakota",
  "block.minecraft.pink_terracotta": "růžová terakota",
  "block.minecraft.gray_terracotta": "šedá terakota",
  "block.minecraft.light_gray_terracotta": "světle šedá terakota",
  "block.minecraft.cyan_terracotta": "azurová terakota",
  "block.minecraft.purple_terracotta": "fialová terakota",
  "block.minecraft.blue_terracotta": "modrá terakota",
  "block.minecraft.brown_terracotta": "hnědá terakota",
  "block.minecraft.green_terracotta": "zelená terakota",
  "block.minecraft.red_terracotta": "červená terakota",
  "block.minecraft.black_terracotta": "černá terakota",
  "block.minecraft.barrier": "bariéra",
  "block.minecraft.iron_trapdoor": "železný poklop",
  "block.minecraft.hay_block": "balík slámy",
  "block.minecraft.white_carpet": "bílý koberec",
  "block.minecraft.orange_carpet": "oranžový koberec",
  "block.minecraft.magenta_carpet": "purpurový koberec",
  "block.minecraft.light_blue_carpet": "světle modrý koberec",
  "block.minecraft.yellow_carpet": "žlutý koberec",
  "block.minecraft.lime_carpet": "světle zelený koberec",
  "block.minecraft.pink_carpet": "růžový koberec",
  "block.minecraft.gray_carpet": "šedý koberec",
  "block.minecraft.light_gray_carpet": "světle šedý koberec",
  "block.minecraft.cyan_carpet": "azurový koberec",
  "block.minecraft.purple_carpet": "fialový koberec",
  "block.minecraft.blue_carpet": "modrý koberec",
  "block.minecraft.brown_carpet": "hnědý koberec",
  "block.minecraft.green_carpet": "zelený koberec",
  "block.minecraft.red_carpet": "červený koberec",
  "block.minecraft.black_carpet": "černý koberec",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "uhelný blok",
  "block.minecraft.packed_ice": "hutný led",
  "block.minecraft.acacia_stairs": "akáciové schody",
  "block.minecraft.dark_oak_stairs": "schody z tmavého dubu",
  "block.minecraft.slime_block": "blok slizu",
  "block.minecraft.grass_path": "pěšina",
  "block.minecraft.sunflower": "slunečnice",
  "block.minecraft.lilac": "šeřík",
  "block.minecraft.rose_bush": "keř růží",
  "block.minecraft.peony": "pivoňka",
  "block.minecraft.tall_grass": "vysoká tráva",
  "block.minecraft.large_fern": "velká kapradina",
  "block.minecraft.white_stained_glass": "bílé sklo",
  "block.minecraft.orange_stained_glass": "oranžové sklo",
  "block.minecraft.magenta_stained_glass": "purpurové sklo",
  "block.minecraft.light_blue_stained_glass": "světle modré sklo",
  "block.minecraft.yellow_stained_glass": "žluté sklo",
  "block.minecraft.lime_stained_glass": "světle zelené sklo",
  "block.minecraft.pink_stained_glass": "růžové sklo",
  "block.minecraft.gray_stained_glass": "šedé sklo",
  "block.minecraft.light_gray_stained_glass": "světle šedé sklo",
  "block.minecraft.cyan_stained_glass": "azurové sklo",
  "block.minecraft.purple_stained_glass": "fialové sklo",
  "block.minecraft.blue_stained_glass": "modré sklo",
  "block.minecraft.brown_stained_glass": "hnědé sklo",
  "block.minecraft.green_stained_glass": "zelené sklo",
  "block.minecraft.red_stained_glass": "červené sklo",
  "block.minecraft.black_stained_glass": "černé sklo",
  "block.minecraft.white_stained_glass_pane": "tabulka bílého skla",
  "block.minecraft.orange_stained_glass_pane": "tabulka oranžového skla",
  "block.minecraft.magenta_stained_glass_pane": "tabulka purpurového skla",
  "block.minecraft.light_blue_stained_glass_pane": "tabulka světle modrého skla",
  "block.minecraft.yellow_stained_glass_pane": "tabulka žlutého skla",
  "block.minecraft.lime_stained_glass_pane": "tabulka světle zeleného skla",
  "block.minecraft.pink_stained_glass_pane": "tabulka růžového skla",
  "block.minecraft.gray_stained_glass_pane": "tabulka šedého skla",
  "block.minecraft.light_gray_stained_glass_pane": "tabulka světle šedého skla",
  "block.minecraft.cyan_stained_glass_pane": "tabulka azurového skla",
  "block.minecraft.purple_stained_glass_pane": "tabulka fialového skla",
  "block.minecraft.blue_stained_glass_pane": "tabulka modrého skla",
  "block.minecraft.brown_stained_glass_pane": "tabulka hnědého skla",
  "block.minecraft.green_stained_glass_pane": "tabulka zeleného skla",
  "block.minecraft.red_stained_glass_pane": "tabulka červeného skla",
  "block.minecraft.black_stained_glass_pane": "tabulka černého skla",
  "block.minecraft.prismarine": "prismarín",
  "block.minecraft.prismarine_bricks": "prismarínové cihly",
  "block.minecraft.dark_prismarine": "tmavý prismarín",
  "block.minecraft.prismarine_stairs": "prismarínové schody",
  "block.minecraft.prismarine_brick_stairs": "schody z prismarínových cihel",
  "block.minecraft.dark_prismarine_stairs": "schody z tmavého prismarínu",
  "block.minecraft.sea_lantern": "mořská lucerna",
  "block.minecraft.red_sandstone": "rudý pískovec",
  "block.minecraft.chiseled_red_sandstone": "opracovaný rudý pískovec",
  "block.minecraft.cut_red_sandstone": "řezaný rudý pískovec",
  "block.minecraft.red_sandstone_stairs": "schody z rudého pískovce",
  "block.minecraft.repeating_command_block": "opakovací příkazový blok",
  "block.minecraft.chain_command_block": "řetězový příkazový blok",
  "block.minecraft.magma_block": "blok magmatu",
  "block.minecraft.nether_wart_block": "blok bradavičníku",
  "block.minecraft.warped_wart_block": "blok přízračného bradavičníku",
  "block.minecraft.red_nether_bricks": "rudé netherové cihly",
  "block.minecraft.bone_block": "kostní blok",
  "block.minecraft.structure_void": "konstrukční void",
  "block.minecraft.observer": "detektor změn",
  "block.minecraft.shulker_box": "shulkerova schránka",
  "block.minecraft.white_shulker_box": "bílá shulkerova schránka",
  "block.minecraft.orange_shulker_box": "oranžová shulkerova schránka",
  "block.minecraft.magenta_shulker_box": "purpurová shulkerova schránka",
  "block.minecraft.light_blue_shulker_box": "světle modrá shulkerova schránka",
  "block.minecraft.yellow_shulker_box": "žlutá shulkerova schránka",
  "block.minecraft.lime_shulker_box": "světle zelená shulkerova schránka",
  "block.minecraft.pink_shulker_box": "růžová shulkerova schránka",
  "block.minecraft.gray_shulker_box": "šedá shulkerova schránka",
  "block.minecraft.light_gray_shulker_box": "světle šedá shulkerova schránka",
  "block.minecraft.cyan_shulker_box": "azurová shulkerova schránka",
  "block.minecraft.purple_shulker_box": "fialová shulkerova schránka",
  "block.minecraft.blue_shulker_box": "modrá shulkerova schránka",
  "block.minecraft.brown_shulker_box": "hnědá shulkerova schránka",
  "block.minecraft.green_shulker_box": "zelená shulkerova schránka",
  "block.minecraft.red_shulker_box": "červená shulkerova schránka",
  "block.minecraft.black_shulker_box": "černá shulkerova schránka",
  "block.minecraft.white_glazed_terracotta": "bílá glazovaná terakota",
  "block.minecraft.orange_glazed_terracotta": "oranžová glazovaná terakota",
  "block.minecraft.magenta_glazed_terracotta": "purpurová glazovaná terakota",
  "block.minecraft.light_blue_glazed_terracotta": "světle modrá glazovaná terakota",
  "block.minecraft.yellow_glazed_terracotta": "žlutá glazovaná terakota",
  "block.minecraft.lime_glazed_terracotta": "světle zelená glazovaná terakota",
  "block.minecraft.pink_glazed_terracotta": "růžová glazovaná terakota",
  "block.minecraft.gray_glazed_terracotta": "šedá glazovaná terakota",
  "block.minecraft.light_gray_glazed_terracotta": "světle šedá glazovaná terakota",
  "block.minecraft.cyan_glazed_terracotta": "azurová glazovaná terakota",
  "block.minecraft.purple_glazed_terracotta": "fialová glazovaná terakota",
  "block.minecraft.blue_glazed_terracotta": "modrá glazovaná terakota",
  "block.minecraft.brown_glazed_terracotta": "hnědá glazovaná terakota",
  "block.minecraft.green_glazed_terracotta": "zelená glazovaná terakota",
  "block.minecraft.red_glazed_terracotta": "červená glazovaná terakota",
  "block.minecraft.black_glazed_terracotta": "černá glazovaná terakota",
  "block.minecraft.white_concrete": "bílý beton",
  "block.minecraft.orange_concrete": "oranžový beton",
  "block.minecraft.magenta_concrete": "purpurový beton",
  "block.minecraft.light_blue_concrete": "světle modrý beton",
  "block.minecraft.yellow_concrete": "žlutý beton",
  "block.minecraft.lime_concrete": "světle zelený beton",
  "block.minecraft.pink_concrete": "růžový beton",
  "block.minecraft.gray_concrete": "šedý beton",
  "block.minecraft.light_gray_concrete": "světle šedý beton",
  "block.minecraft.cyan_concrete": "azurový beton",
  "block.minecraft.purple_concrete": "fialový beton",
  "block.minecraft.blue_concrete": "modrý beton",
  "block.minecraft.brown_concrete": "hnědý beton",
  "block.minecraft.green_concrete": "zelený beton",
  "block.minecraft.red_concrete": "červený beton",
  "block.minecraft.black_concrete": "černý beton",
  "block.minecraft.white_concrete_powder": "bílý cement",
  "block.minecraft.orange_concrete_powder": "oranžový cement",
  "block.minecraft.magenta_concrete_powder": "purpurový cement",
  "block.minecraft.light_blue_concrete_powder": "světle modrý cement",
  "block.minecraft.yellow_concrete_powder": "žlutý cement",
  "block.minecraft.lime_concrete_powder": "světle zelený cement",
  "block.minecraft.pink_concrete_powder": "růžový cement",
  "block.minecraft.gray_concrete_powder": "šedý cement",
  "block.minecraft.light_gray_concrete_powder": "světle šedý cement",
  "block.minecraft.cyan_concrete_powder": "azurový cement",
  "block.minecraft.purple_concrete_powder": "fialový cement",
  "block.minecraft.blue_concrete_powder": "modrý cement",
  "block.minecraft.brown_concrete_powder": "hnědý cement",
  "block.minecraft.green_concrete_powder": "zelený cement",
  "block.minecraft.red_concrete_powder": "červený cement",
  "block.minecraft.black_concrete_powder": "černý cement",
  "block.minecraft.turtle_egg": "želví vajíčko",
  "block.minecraft.dead_tube_coral_block": "blok mrtvého varhanitkového korálu",
  "block.minecraft.dead_brain_coral_block": "blok mrtvého mozkového korálu",
  "block.minecraft.dead_bubble_coral_block": "blok mrtvého bublinového korálu",
  "block.minecraft.dead_fire_coral_block": "blok mrtvého žahavkového korálu",
  "block.minecraft.dead_horn_coral_block": "blok mrtvého drsnatého korálu",
  "block.minecraft.tube_coral_block": "blok varhanitkového korálu",
  "block.minecraft.brain_coral_block": "blok mozkového korálu",
  "block.minecraft.bubble_coral_block": "blok bublinového korálu",
  "block.minecraft.fire_coral_block": "blok žahavkového korálu",
  "block.minecraft.horn_coral_block": "blok drsnatého korálu",
  "block.minecraft.tube_coral": "varhanitkový korál",
  "block.minecraft.brain_coral": "mozkový korál",
  "block.minecraft.bubble_coral": "bublinový korál",
  "block.minecraft.fire_coral": "žahavkový korál",
  "block.minecraft.horn_coral": "drsnatý korál",
  "block.minecraft.dead_brain_coral": "mrtvý mozkový korál",
  "block.minecraft.dead_bubble_coral": "mrtvý bublinový korál",
  "block.minecraft.dead_fire_coral": "mrtvý žahavkový korál",
  "block.minecraft.dead_horn_coral": "mrtvý drsnatý korál",
  "block.minecraft.dead_tube_coral": "mrtvý varhanitkový korál",
  "block.minecraft.tube_coral_fan": "vějíř varhanitkového korálu",
  "block.minecraft.brain_coral_fan": "vějíř mozkového korálu",
  "block.minecraft.bubble_coral_fan": "vějíř bublinového korálu",
  "block.minecraft.fire_coral_fan": "vějíř žahavkového korálu",
  "block.minecraft.horn_coral_fan": "vějíř drsnatého korálu",
  "block.minecraft.dead_tube_coral_fan": "blok mrtvého varhanitkového korálu",
  "block.minecraft.dead_brain_coral_fan": "blok mrtvého mozkového korálu",
  "block.minecraft.dead_bubble_coral_fan": "blok mrtvého bublinového korálu",
  "block.minecraft.dead_fire_coral_fan": "blok mrtvého žahavkového korálu",
  "block.minecraft.dead_horn_coral_fan": "blok mrtvého drsnatého korálu",
  "block.minecraft.blue_ice": "modrý led",
  "block.minecraft.conduit": "zářič",
  "block.minecraft.polished_granite_stairs": "schody z leštěné žuly",
  "block.minecraft.smooth_red_sandstone_stairs": "schody z vyhlazeného rudého pískovce",
  "block.minecraft.mossy_stone_brick_stairs": "omšelé schody z kamenných cihel",
  "block.minecraft.polished_diorite_stairs": "schody z leštěného dioritu",
  "block.minecraft.mossy_cobblestone_stairs": "omšelé schody z kamení",
  "block.minecraft.end_stone_brick_stairs": "schody z enderitových cihel",
  "block.minecraft.stone_stairs": "kamenné schody",
  "block.minecraft.smooth_sandstone_stairs": "schody z vyhlazeného pískovce",
  "block.minecraft.smooth_quartz_stairs": "schody z hladkého křemene",
  "block.minecraft.granite_stairs": "žulové schody",
  "block.minecraft.andesite_stairs": "andezitové schody",
  "block.minecraft.red_nether_brick_stairs": "schody z rudých netherových cihel",
  "block.minecraft.polished_andesite_stairs": "schody z leštěného andezitu",
  "block.minecraft.diorite_stairs": "dioritové schody",
  "block.minecraft.polished_granite_slab": "půlblok z leštěné žuly",
  "block.minecraft.smooth_red_sandstone_slab": "půlblok z vyhlazeného rudého pískovce",
  "block.minecraft.mossy_stone_brick_slab": "omšelý půlblok z kamenných cihel",
  "block.minecraft.polished_diorite_slab": "půlblok z leštěného dioritu",
  "block.minecraft.mossy_cobblestone_slab": "omšelý půlblok z kamení",
  "block.minecraft.end_stone_brick_slab": "půlblok z enderitových cihel",
  "block.minecraft.smooth_sandstone_slab": "půlblok z vyhlazeného pískovce",
  "block.minecraft.smooth_quartz_slab": "půlblok z hladkého křemene",
  "block.minecraft.granite_slab": "žulový půlblok",
  "block.minecraft.andesite_slab": "andezitový půlblok",
  "block.minecraft.red_nether_brick_slab": "půlblok z rudých netherových cihel",
  "block.minecraft.polished_andesite_slab": "půlblok z leštěného andezitu",
  "block.minecraft.diorite_slab": "dioritový půlblok",
  "block.minecraft.scaffolding": "lešení",
  "block.minecraft.iron_door": "železné dveře",
  "block.minecraft.oak_door": "dubové dveře",
  "block.minecraft.spruce_door": "smrkové dveře",
  "block.minecraft.birch_door": "březové dveře",
  "block.minecraft.jungle_door": "dveře z tropického dřeva",
  "block.minecraft.acacia_door": "akáciové dveře",
  "block.minecraft.dark_oak_door": "dveře z tmavého dubu",
  "block.minecraft.crimson_door": "karmínové dveře",
  "block.minecraft.warped_door": "přízračné dveře",
  "block.minecraft.repeater": "ruditový zesilovač",
  "block.minecraft.comparator": "ruditový porovnávač",
  "block.minecraft.structure_block": "konstrukční blok",
  "block.minecraft.jigsaw": "blok skládačky",
  "item.minecraft.turtle_helmet": "helma z želvoviny□□když na hlavě:□+2 zbroj",
  "item.minecraft.scute": "želví destička",
  "item.minecraft.iron_shovel": "železná lopata□□když v dominantní ruce:□+3.5 síla útoku□-3 rychlost útoku",
  "item.minecraft.iron_pickaxe": "železný krumpáč□□když v dominantní ruce:□+3 síla útoku□-2.8 rychlost útoku",
  "item.minecraft.iron_axe": "železná sekera□□když v dominantní ruce:□+8 síla útoku□-3.1 rychlost útoku",
  "item.minecraft.flint_and_steel": "křesadlo",
  "item.minecraft.apple": "jablko",
  "item.minecraft.bow": "luk",
  "item.minecraft.arrow": "šíp",
  "item.minecraft.coal": "uhlí",
  "item.minecraft.charcoal": "dřevěné uhlí",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "železný ingot",
  "item.minecraft.gold_ingot": "zlatý ingot",
  "item.minecraft.netherite_ingot": "netheritový ingot",
  "item.minecraft.netherite_scrap": "netheritový plátek",
  "item.minecraft.iron_sword": "železný meč□□když v dominantní ruce:□+5 síla útoku□-2.4 rychlost útoku",
  "item.minecraft.wooden_sword": "dřevěný meč□□když v dominantní ruce:□+3 síla útoku□-2.4 rychlost útoku",
  "item.minecraft.wooden_shovel": "dřevěná lopata□□když v dominantní ruce:□+1.5 síla útoku□-3 rychlost útoku",
  "item.minecraft.wooden_pickaxe": "dřevěný krumpáč□□když v dominantní ruce:□+1 síla útoku□-2.8 rychlost útoku",
  "item.minecraft.wooden_axe": "dřevěná sekera□□když v dominantní ruce:□+6 síla útoku□-3.2 rychlost útoku",
  "item.minecraft.stone_sword": "kamenný meč□□když v dominantní ruce:□+4 síla útoku□-2.4 rychlost útoku",
  "item.minecraft.stone_shovel": "kamenná lopata□□když v dominantní ruce:□+2.5 síla útoku□-3 rychlost útoku",
  "item.minecraft.stone_pickaxe": "kamenný krumpáč□□když v dominantní ruce:□+2 síla útoku□-2.8 rychlost útoku",
  "item.minecraft.stone_axe": "kamenná sekera□□když v dominantní ruce:□+8 síla útoku□-3.2 rychlost útoku",
  "item.minecraft.diamond_sword": "diamantový meč□□když v dominantní ruce:□+6 síla útoku□-2.4 rychlost útoku",
  "item.minecraft.diamond_shovel": "diamantová lopata□□když v dominantní ruce:□+4.5 síla útoku□-3 rychlost útoku",
  "item.minecraft.diamond_pickaxe": "diamantový krumpáč□□když v dominantní ruce:□+4 síla útoku□-2.8 rychlost útoku",
  "item.minecraft.diamond_axe": "diamantová sekera□□když v dominantní ruce:□+8 síla útoku□-3 rychlost útoku",
  "item.minecraft.stick": "tyčka",
  "item.minecraft.bowl": "miska",
  "item.minecraft.mushroom_stew": "houbová polévka",
  "item.minecraft.golden_sword": "zlatý meč□□když v dominantní ruce:□+3 síla útoku□-2.4 rychlost útoku",
  "item.minecraft.golden_shovel": "zlatá lopata□□když v dominantní ruce:□+1.5 síla útoku□-3 rychlost útoku",
  "item.minecraft.golden_pickaxe": "zlatý krumpáč□□když v dominantní ruce:□+1 síla útoku□-2.8 rychlost útoku",
  "item.minecraft.golden_axe": "zlatá sekera□□když v dominantní ruce:□+6 síla útoku□-3 rychlost útoku",
  "item.minecraft.netherite_sword": "netheritový meč□□když v dominantní ruce:□+7 síla útoku□-2.4 rychlost útoku",
  "item.minecraft.netherite_shovel": "netheritová lopata□□když v dominantní ruce:□+5.5 síla útoku□-3 rychlost útoku",
  "item.minecraft.netherite_pickaxe": "netheritový krumpáč□□když v dominantní ruce:□+5 síla útoku□-2.8 rychlost útoku",
  "item.minecraft.netherite_axe": "netheritová sekera□□když v dominantní ruce:□+9 síla útoku□-3 rychlost útoku",
  "item.minecraft.string": "vlákno",
  "item.minecraft.feather": "pírko",
  "item.minecraft.gunpowder": "střelný prach",
  "item.minecraft.wooden_hoe": "dřevěná motyka□□když v dominantní ruce:□-3 rychlost útoku",
  "item.minecraft.stone_hoe": "kamenná motyka□□když v dominantní ruce:□-2 rychlost útoku",
  "item.minecraft.iron_hoe": "železná motyka□□když v dominantní ruce:□-1 rychlost útoku",
  "item.minecraft.diamond_hoe": "diamantová motyka□□když v dominantní ruce:",
  "item.minecraft.golden_hoe": "zlatá motyka□□když v dominantní ruce:□-3 rychlost útoku",
  "item.minecraft.netherite_hoe": "netheritová motyka□□když v dominantní ruce:",
  "item.minecraft.wheat_seeds": "semínka pšenice",
  "item.minecraft.wheat": "pšenice",
  "item.minecraft.bread": "chléb",
  "item.minecraft.leather_helmet": "kožená čapka□□když na hlavě:□+1 zbroj",
  "item.minecraft.leather_chestplate": "kožená tunika□□když na těle:□+3 zbroj",
  "item.minecraft.leather_leggings": "kožené kalhoty□□když na nohou:□+2 zbroj",
  "item.minecraft.leather_boots": "kožené boty□□když na chodidlech:□+1 zbroj",
  "item.minecraft.chainmail_helmet": "kroužková kapuce□□když na hlavě:□+2 zbroj",
  "item.minecraft.chainmail_chestplate": "kroužková košile□□když na těle:□+5 zbroj",
  "item.minecraft.chainmail_leggings": "kroužkové kalhoty□□když na nohou:□+4 zbroj",
  "item.minecraft.chainmail_boots": "kroužkové boty□□když na chodidlech:□+1 zbroj",
  "item.minecraft.iron_helmet": "železná helma□□když na hlavě:□+2 zbroj",
  "item.minecraft.iron_chestplate": "železné brnění□□když na těle:□+6 zbroj",
  "item.minecraft.iron_leggings": "železné kalhoty□□když na nohou:□+5 zbroj",
  "item.minecraft.iron_boots": "železné boty□□když na chodidlech:□+2 zbroj",
  "item.minecraft.diamond_helmet": "diamantová helma□□když na hlavě:□+3 zbroj□+2 odolnost zbroje",
  "item.minecraft.diamond_chestplate": "diamantové brnění□□když na těle:□+8 zbroj□+2 odolnost zbroje",
  "item.minecraft.diamond_leggings": "diamantové kalhoty□□když na nohou:□+6 zbroj□+2 odolnost zbroje",
  "item.minecraft.diamond_boots": "diamantové boty□□když na chodidlech:□+3 zbroj□+2 odolnost zbroje",
  "item.minecraft.golden_helmet": "zlatá helma□□když na hlavě:□+2 zbroj",
  "item.minecraft.golden_chestplate": "zlaté brnění□□když na těle:□+5 zbroj",
  "item.minecraft.golden_leggings": "zlaté kalhoty□□když na nohou:□+3 zbroj",
  "item.minecraft.golden_boots": "zlaté boty□□když na chodidlech:□+1 zbroj",
  "item.minecraft.netherite_helmet": "netheritová helma□□když na hlavě:□+3 zbroj□+3 odolnost zbroje□+1 odolnost proti odražení",
  "item.minecraft.netherite_chestplate": "netheritové brnění□□když na těle:□+8 zbroj□+3 odolnost zbroje□+1 odolnost proti odražení",
  "item.minecraft.netherite_leggings": "netheritové kalhoty□□když na nohou:□+6 zbroj□+3 odolnost zbroje□+1 odolnost proti odražení",
  "item.minecraft.netherite_boots": "netheritové boty□□když na chodidlech:□+3 zbroj□+3 odolnost zbroje□+1 odolnost proti odražení",
  "item.minecraft.flint": "pazourek",
  "item.minecraft.porkchop": "syrová kotleta",
  "item.minecraft.cooked_porkchop": "pečená kotleta",
  "item.minecraft.painting": "obraz",
  "item.minecraft.golden_apple": "zlaté jablko",
  "item.minecraft.enchanted_golden_apple": "očarované zlaté jablko",
  "block.minecraft.oak_sign": "dubová cedule",
  "block.minecraft.spruce_sign": "smrková cedule",
  "block.minecraft.birch_sign": "březová cedule",
  "block.minecraft.jungle_sign": "cedule z tropického dřeva",
  "block.minecraft.acacia_sign": "akáciová cedule",
  "block.minecraft.dark_oak_sign": "cedule z tmavého dubu",
  "block.minecraft.crimson_sign": "karmínová cedule",
  "block.minecraft.warped_sign": "přízračná cedule",
  "item.minecraft.bucket": "kbelík",
  "item.minecraft.water_bucket": "kbelík vody",
  "item.minecraft.lava_bucket": "kbelík lávy",
  "item.minecraft.minecart": "vozík",
  "item.minecraft.saddle": "sedlo",
  "item.minecraft.redstone": "ruditový prášek",
  "item.minecraft.snowball": "sněhová koule",
  "item.minecraft.oak_boat": "dubový člun",
  "item.minecraft.leather": "kůže",
  "item.minecraft.milk_bucket": "mléko",
  "item.minecraft.pufferfish_bucket": "kbelík se čtverzubcem",
  "item.minecraft.salmon_bucket": "kbelík s lososem",
  "item.minecraft.cod_bucket": "kbelík s treskou",
  "item.minecraft.tropical_fish_bucket": "kbelík s tropickou rybou",
  "item.minecraft.brick": "cihla",
  "item.minecraft.clay_ball": "hrouda jílu",
  "block.minecraft.dried_kelp_block": "balík sušených chaluh",
  "item.minecraft.paper": "papír",
  "item.minecraft.book": "kniha",
  "item.minecraft.slime_ball": "sliz",
  "item.minecraft.chest_minecart": "nákladní vozík",
  "item.minecraft.furnace_minecart": "parní vozík",
  "item.minecraft.egg": "vajíčko",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "rybářský prut",
  "item.minecraft.clock": "hodiny",
  "item.minecraft.glowstone_dust": "světlitový prášek",
  "item.minecraft.cod": "syrová treska",
  "item.minecraft.salmon": "syrový losos",
  "item.minecraft.tropical_fish": "tropická ryba",
  "item.minecraft.pufferfish": "čtverzubec",
  "item.minecraft.cooked_cod": "pečená treska",
  "item.minecraft.cooked_salmon": "pečený losos",
  "item.minecraft.ink_sac": "váček inkoustu",
  "item.minecraft.red_dye": "červené barvivo",
  "item.minecraft.green_dye": "zelené barvivo",
  "item.minecraft.cocoa_beans": "kakaové boby",
  "item.minecraft.lapis_lazuli": "lazurit",
  "item.minecraft.purple_dye": "fialové barvivo",
  "item.minecraft.cyan_dye": "azurové barvivo",
  "item.minecraft.light_gray_dye": "světle šedé barvivo",
  "item.minecraft.gray_dye": "šedé barvivo",
  "item.minecraft.pink_dye": "růžové barvivo",
  "item.minecraft.lime_dye": "světle zelené barvivo",
  "item.minecraft.yellow_dye": "žluté barvivo",
  "item.minecraft.light_blue_dye": "světle modré barvivo",
  "item.minecraft.magenta_dye": "purpurové barvivo",
  "item.minecraft.orange_dye": "oranžové barvivo",
  "item.minecraft.bone_meal": "kostní moučka",
  "item.minecraft.blue_dye": "modré barvivo",
  "item.minecraft.brown_dye": "hnědé barvivo",
  "item.minecraft.black_dye": "černé barvivo",
  "item.minecraft.white_dye": "bílé barvivo",
  "item.minecraft.bone": "kost",
  "item.minecraft.sugar": "cukr",
  "block.minecraft.cake": "dort",
  "block.minecraft.white_bed": "bílá postel",
  "block.minecraft.orange_bed": "oranžová postel",
  "block.minecraft.magenta_bed": "purpurová postel",
  "block.minecraft.light_blue_bed": "světle modrá postel",
  "block.minecraft.yellow_bed": "žlutá postel",
  "block.minecraft.lime_bed": "světle zelená postel",
  "block.minecraft.pink_bed": "růžová postel",
  "block.minecraft.gray_bed": "šedá postel",
  "block.minecraft.light_gray_bed": "světle šedá postel",
  "block.minecraft.cyan_bed": "azurová postel",
  "block.minecraft.purple_bed": "fialová postel",
  "block.minecraft.blue_bed": "modrá postel",
  "block.minecraft.brown_bed": "hnědá postel",
  "block.minecraft.green_bed": "zelená postel",
  "block.minecraft.red_bed": "červená postel",
  "block.minecraft.black_bed": "černá postel",
  "item.minecraft.cookie": "sušenka",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "nůžky",
  "item.minecraft.melon_slice": "kousek melounu",
  "item.minecraft.dried_kelp": "sušená chaluha",
  "item.minecraft.pumpkin_seeds": "dýňová semínka",
  "item.minecraft.melon_seeds": "semínka melounu",
  "item.minecraft.beef": "syrový steak",
  "item.minecraft.cooked_beef": "propečený steak",
  "item.minecraft.chicken": "syrové kuře",
  "item.minecraft.cooked_chicken": "pečené kuře",
  "item.minecraft.rotten_flesh": "shnilé maso",
  "item.minecraft.ender_pearl": "endová perla",
  "item.minecraft.blaze_rod": "ohnivá hůl",
  "item.minecraft.ghast_tear": "ďasova slza",
  "item.minecraft.gold_nugget": "zlatý nuget",
  "item.minecraft.nether_wart": "bradavičník",
  "item.minecraft.potion": "nevytvořitelný lektvar□žádné účinky",
  "item.minecraft.glass_bottle": "lahvička",
  "item.minecraft.spider_eye": "pavoučí oko",
  "item.minecraft.fermented_spider_eye": "zkvašené pavoučí oko",
  "item.minecraft.blaze_powder": "ohnivý prach",
  "item.minecraft.magma_cream": "lávová pěna",
  "block.minecraft.brewing_stand": "varný stojan",
  "block.minecraft.cauldron": "kotel",
  "item.minecraft.ender_eye": "endové oko",
  "item.minecraft.glistering_melon_slice": "zlatavý kousek melounu",
  "item.minecraft.bat_spawn_egg": "vajíčko s netopýrem",
  "item.minecraft.bee_spawn_egg": "vajíčko se včelou",
  "item.minecraft.blaze_spawn_egg": "vajíčko s ohnivákem",
  "item.minecraft.cat_spawn_egg": "vajíčko s kočkou",
  "item.minecraft.cave_spider_spawn_egg": "vajíčko s jeskynním pavoukem",
  "item.minecraft.chicken_spawn_egg": "vajíčko se slepicí",
  "item.minecraft.cod_spawn_egg": "vajíčko s treskou",
  "item.minecraft.cow_spawn_egg": "vajíčko s krávou",
  "item.minecraft.creeper_spawn_egg": "vajíčko s creeperem",
  "item.minecraft.dolphin_spawn_egg": "vajíčko s delfínem",
  "item.minecraft.donkey_spawn_egg": "vajíčko s oslem",
  "item.minecraft.drowned_spawn_egg": "vajíčko s utopencem",
  "item.minecraft.elder_guardian_spawn_egg": "vajíčko s prastrážcem",
  "item.minecraft.enderman_spawn_egg": "vajíčko s endermanem",
  "item.minecraft.endermite_spawn_egg": "vajíčko s endermitem",
  "item.minecraft.evoker_spawn_egg": "vajíčko s mágem",
  "item.minecraft.fox_spawn_egg": "vajíčko s liškou",
  "item.minecraft.ghast_spawn_egg": "vajíčko s ďasem",
  "item.minecraft.guardian_spawn_egg": "vajíčko se strážcem",
  "item.minecraft.hoglin_spawn_egg": "vajíčko s hoglinem",
  "item.minecraft.horse_spawn_egg": "vajíčko s koněm",
  "item.minecraft.husk_spawn_egg": "vajíčko s pouštní zombie",
  "item.minecraft.llama_spawn_egg": "vajíčko s lamou",
  "item.minecraft.magma_cube_spawn_egg": "vajíčko s magmaslizounem",
  "item.minecraft.mooshroom_spawn_egg": "vajíčko s krávomůrkou",
  "item.minecraft.mule_spawn_egg": "vajíčko s mulou",
  "item.minecraft.ocelot_spawn_egg": "vajíčko s ocelotem",
  "item.minecraft.panda_spawn_egg": "vajíčko s pandou",
  "item.minecraft.parrot_spawn_egg": "vajíčko s papouškem",
  "item.minecraft.phantom_spawn_egg": "vajíčko s přízrakem",
  "item.minecraft.pig_spawn_egg": "vajíčko s prasetem",
  "item.minecraft.piglin_spawn_egg": "vajíčko s piglinem",
  "item.minecraft.pillager_spawn_egg": "vajíčko s nájezdníkem",
  "item.minecraft.polar_bear_spawn_egg": "vajíčko s ledním medvědem",
  "item.minecraft.pufferfish_spawn_egg": "vajíčko se čtverzubcem",
  "item.minecraft.rabbit_spawn_egg": "vajíčko s králíkem",
  "item.minecraft.ravager_spawn_egg": "vajíčko s ničitelem",
  "item.minecraft.salmon_spawn_egg": "vajíčko s lososem",
  "item.minecraft.sheep_spawn_egg": "vajíčko s ovcí",
  "item.minecraft.shulker_spawn_egg": "vajíčko se shulkerem",
  "item.minecraft.silverfish_spawn_egg": "vajíčko s rybenkou",
  "item.minecraft.skeleton_spawn_egg": "vajíčko s kostlivcem",
  "item.minecraft.skeleton_horse_spawn_egg": "vajíčko s koňským kostlivcem",
  "item.minecraft.slime_spawn_egg": "vajíčko se slizounem",
  "item.minecraft.spider_spawn_egg": "vajíčko s pavoukem",
  "item.minecraft.squid_spawn_egg": "vajíčko s chobotnicí",
  "item.minecraft.stray_spawn_egg": "vajíčko s tulákem",
  "item.minecraft.strider_spawn_egg": "vajíčko s lávouchem",
  "item.minecraft.trader_llama_spawn_egg": "vajíčko s obchodníkovou lamou",
  "item.minecraft.tropical_fish_spawn_egg": "vajíčko s tropickou rybou",
  "item.minecraft.turtle_spawn_egg": "vajíčko se želvou",
  "item.minecraft.vex_spawn_egg": "vajíčko s protivou",
  "item.minecraft.villager_spawn_egg": "vajíčko s vesničanem",
  "item.minecraft.vindicator_spawn_egg": "vajíčko se mstitelem",
  "item.minecraft.wandering_trader_spawn_egg": "vajíčko s potulným obchodníkem",
  "item.minecraft.witch_spawn_egg": "vajíčko s čarodějnicí",
  "item.minecraft.wither_skeleton_spawn_egg": "vajíčko s wither kostlivcem",
  "item.minecraft.wolf_spawn_egg": "vajíčko s vlkem",
  "item.minecraft.zoglin_spawn_egg": "vajíčko se zoglinem",
  "item.minecraft.zombie_spawn_egg": "vajíčko se zombie",
  "item.minecraft.zombie_horse_spawn_egg": "vajíčko se zombie koněm",
  "item.minecraft.zombie_villager_spawn_egg": "vajíčko se zombie vesničanem",
  "item.minecraft.zombified_piglin_spawn_egg": "vajíčko se zombie piglinem",
  "item.minecraft.experience_bottle": "lektvar očarování",
  "item.minecraft.fire_charge": "ohnivá koule",
  "item.minecraft.writable_book": "rozepsaná kniha s brkem",
  "item.minecraft.written_book": "napsaná kniha",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "rámeček",
  "block.minecraft.flower_pot": "květináč",
  "item.minecraft.carrot": "mrkev",
  "item.minecraft.potato": "brambora",
  "item.minecraft.baked_potato": "pečená brambora",
  "item.minecraft.poisonous_potato": "jedovatá brambora",
  "item.minecraft.map": "prázdná mapa",
  "item.minecraft.golden_carrot": "zlatá mrkev",
  "block.minecraft.skeleton_skull": "lebka kostlivce",
  "block.minecraft.wither_skeleton_skull": "lebka wither kostlivce",
  "block.minecraft.player_head": "hlava hráče",
  "block.minecraft.zombie_head": "hlava zombie",
  "block.minecraft.creeper_head": "hlava creepera",
  "block.minecraft.dragon_head": "hlava draka",
  "item.minecraft.carrot_on_a_stick": "mrkev na prutu",
  "item.minecraft.warped_fungus_on_a_stick": "přízračná houba na udici",
  "item.minecraft.nether_star": "netherová hvězda",
  "item.minecraft.pumpkin_pie": "dýňový koláč",
  "item.minecraft.firework_rocket": "rachejtle",
  "item.minecraft.firework_star": "ohňostrojová hvězda",
  "item.minecraft.enchanted_book": "očarovaná kniha",
  "item.minecraft.nether_brick": "netherová cihla",
  "item.minecraft.quartz": "netherový křemen",
  "item.minecraft.tnt_minecart": "vozík s tnt",
  "item.minecraft.hopper_minecart": "vozík s násypkou",
  "item.minecraft.prismarine_shard": "prismarínový střep",
  "item.minecraft.prismarine_crystals": "prismarínový krystal",
  "item.minecraft.rabbit": "syrový králík",
  "item.minecraft.cooked_rabbit": "pečený králík",
  "item.minecraft.rabbit_stew": "králičí guláš",
  "item.minecraft.rabbit_foot": "králičí pacička",
  "item.minecraft.rabbit_hide": "králičí kůže",
  "item.minecraft.armor_stand": "stojan na zbroj",
  "item.minecraft.iron_horse_armor": "železná zbroj pro koně",
  "item.minecraft.golden_horse_armor": "zlatá zbroj pro koně",
  "item.minecraft.diamond_horse_armor": "diamantová zbroj pro koně",
  "item.minecraft.leather_horse_armor": "kožená zbroj pro koně",
  "item.minecraft.lead": "vodítko",
  "item.minecraft.name_tag": "jmenovka",
  "item.minecraft.command_block_minecart": "vozík s příkazovým blokem",
  "item.minecraft.mutton": "syrové skopové",
  "item.minecraft.cooked_mutton": "pečené skopové",
  "block.minecraft.white_banner": "bílý prapor",
  "block.minecraft.orange_banner": "oranžový prapor",
  "block.minecraft.magenta_banner": "purpurový prapor",
  "block.minecraft.light_blue_banner": "světle modrý prapor",
  "block.minecraft.yellow_banner": "žlutý prapor",
  "block.minecraft.lime_banner": "světle zelený prapor",
  "block.minecraft.pink_banner": "růžový prapor",
  "block.minecraft.gray_banner": "šedý prapor",
  "block.minecraft.light_gray_banner": "světle šedý prapor",
  "block.minecraft.cyan_banner": "azurový prapor",
  "block.minecraft.purple_banner": "fialový prapor",
  "block.minecraft.blue_banner": "modrý prapor",
  "block.minecraft.brown_banner": "hnědý prapor",
  "block.minecraft.green_banner": "zelený prapor",
  "block.minecraft.red_banner": "červený prapor",
  "block.minecraft.black_banner": "černý prapor",
  "item.minecraft.end_crystal": "endový krystal",
  "item.minecraft.chorus_fruit": "plod chorusu",
  "item.minecraft.popped_chorus_fruit": "vypukaný květ chorusu",
  "item.minecraft.beetroot": "červená řepa",
  "item.minecraft.beetroot_seeds": "semínka červené řepy",
  "item.minecraft.beetroot_soup": "polévka z červené řepy",
  "item.minecraft.dragon_breath": "dračí dech",
  "item.minecraft.splash_potion": "vrhací nevytvořitelný lektvar□žádné účinky",
  "item.minecraft.spectral_arrow": "přízračný šíp",
  "item.minecraft.tipped_arrow": "nevytvořitelný namočený šíp□žádné účinky",
  "item.minecraft.lingering_potion": "doznívající nevytvořitelný lektvar□žádné účinky",
  "item.minecraft.shield": "štít",
  "item.minecraft.elytra": "krovky",
  "item.minecraft.spruce_boat": "smrkový člun",
  "item.minecraft.birch_boat": "březový člun",
  "item.minecraft.jungle_boat": "člun z tropického dřeva",
  "item.minecraft.acacia_boat": "akáciový člun",
  "item.minecraft.dark_oak_boat": "člun z tmavého dubu",
  "item.minecraft.totem_of_undying": "totem nesmrtelnosti",
  "item.minecraft.shulker_shell": "shulkerův krunýř",
  "item.minecraft.iron_nugget": "železný nuget",
  "item.minecraft.knowledge_book": "kniha vědění",
  "item.minecraft.debug_stick": "ladicí hůlka",
  "item.minecraft.music_disc_13": "gramofonová deska□c418 - 13",
  "item.minecraft.music_disc_cat": "gramofonová deska□c418 - cat",
  "item.minecraft.music_disc_blocks": "gramofonová deska□c418 - blocks",
  "item.minecraft.music_disc_chirp": "gramofonová deska□c418 - chirp",
  "item.minecraft.music_disc_far": "gramofonová deska□c418 - far",
  "item.minecraft.music_disc_mall": "gramofonová deska□c418 - mall",
  "item.minecraft.music_disc_mellohi": "gramofonová deska□c418 - mellohi",
  "item.minecraft.music_disc_stal": "gramofonová deska□c418 - stal",
  "item.minecraft.music_disc_strad": "gramofonová deska□c418 - strad",
  "item.minecraft.music_disc_ward": "gramofonová deska□c418 - ward",
  "item.minecraft.music_disc_11": "gramofonová deska□c418 - 11",
  "item.minecraft.music_disc_wait": "gramofonová deska□c418 - wait",
  "item.minecraft.music_disc_pigstep": "gramofonová deska□lena raine – pigstep",
  "item.minecraft.trident": "trojzubec□□když v dominantní ruce:□+8 síla útoku□-2.9 rychlost útoku",
  "item.minecraft.phantom_membrane": "blána přízraku",
  "item.minecraft.nautilus_shell": "ulita loděnky",
  "item.minecraft.heart_of_the_sea": "srdce moře",
  "item.minecraft.crossbow": "kuše",
  "item.minecraft.suspicious_stew": "nevábná šlichta",
  "block.minecraft.loom": "tkalcovský stav",
  "item.minecraft.flower_banner_pattern": "vzor praporu□květ",
  "item.minecraft.creeper_banner_pattern": "vzor praporu□tvář creepera",
  "item.minecraft.skull_banner_pattern": "vzor praporu□lebka",
  "item.minecraft.mojang_banner_pattern": "vzor praporu□znak",
  "item.minecraft.globe_banner_pattern": "vzor praporu□zeměkostka",
  "item.minecraft.piglin_banner_pattern": "vzor praporu□rypák",
  "block.minecraft.composter": "kompostér",
  "block.minecraft.barrel": "sud",
  "block.minecraft.smoker": "trouba",
  "block.minecraft.blast_furnace": "tavicí pec",
  "block.minecraft.cartography_table": "kartografický stůl",
  "block.minecraft.fletching_table": "stůl na výrobu šípů",
  "block.minecraft.grindstone": "brusný kámen",
  "block.minecraft.lectern": "čtecí pult",
  "block.minecraft.smithing_table": "kovářský stůl",
  "block.minecraft.stonecutter": "řezačka kamene",
  "block.minecraft.bell": "zvon",
  "block.minecraft.lantern": "lucerna",
  "block.minecraft.soul_lantern": "lucerna duší",
  "item.minecraft.sweet_berries": "sladké bobule",
  "block.minecraft.campfire": "táborák",
  "block.minecraft.soul_campfire": "táborák s ohněm duší",
  "block.minecraft.shroomlight": "světlohubka",
  "item.minecraft.honeycomb": "plástev medu",
  "block.minecraft.bee_nest": "včelí hnízdo",
  "block.minecraft.beehive": "včelí úl",
  "item.minecraft.honey_bottle": "lahvička medu",
  "block.minecraft.honey_block": "blok medu",
  "block.minecraft.honeycomb_block": "blok medových pláství",
  "block.minecraft.lodestone": "navigační kámen",
  "block.minecraft.netherite_block": "blok netheritu",
  "block.minecraft.ancient_debris": "prastará suť",
  "block.minecraft.target": "terč",
  "block.minecraft.crying_obsidian": "plačící obsidián",
  "block.minecraft.blackstone": "černokámen",
  "block.minecraft.blackstone_slab": "černokamenný půlblok",
  "block.minecraft.blackstone_stairs": "černokamenné schody",
  "block.minecraft.gilded_blackstone": "zlatonosný černokámen",
  "block.minecraft.polished_blackstone": "leštěný černokámen",
  "block.minecraft.polished_blackstone_slab": "půlblok z leštěného černokamene",
  "block.minecraft.polished_blackstone_stairs": "schody z leštěného černokamene",
  "block.minecraft.chiseled_polished_blackstone": "opracovaný leštěný černokámen",
  "block.minecraft.polished_blackstone_bricks": "cihly z leštěného černokamene",
  "block.minecraft.polished_blackstone_brick_slab": "půlblok z cihel z leštěného černokamene",
  "block.minecraft.polished_blackstone_brick_stairs": "schody z cihel z leštěného černokamene",
  "block.minecraft.cracked_polished_blackstone_bricks": "popraskané cihly z leštěného černokamene",
  "block.minecraft.respawn_anchor": "kotva oživení",
}
export const cs_cz = items; 
